export default __webpack_public_path__ + "static/media/iso.1cc47748.pdf";